import * as _ from "lodash";
import React, { useState } from "react";
import SideNavActions from "./SideNavActions";
import Search from "./Search";
import Filters from "./Filters";
import NavigationContainer from "./NavigationContainer";
import ToggleSibligsButtons from "./ToggleSibligsButtons";
import * as Models from "../../../Models";
import azureStore from "../../../Store/azureStore";

interface SideNavProps {
    // isLoading: boolean;
    match: Models.Match;
    location: Models.Location;
}

export default function SideNav(props: SideNavProps) {
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const collapse = () => setCollapsed(!collapsed);
    const { match, location } = props;
    const isLoading = azureStore().getIsLoading();
    const className: string = collapsed
        ? "Content__sidenav Content__sidenav--collapsed"
        : "Content__sidenav";

    return (
        <div className={className}>
            <SideNavActions collapsed={collapsed} onCollapse={collapse} />
            <Search
                match={match}
                location={location}
                isModalSelectionMode={false}
            />
            <Filters
                match={match}
                location={location}
                isModalSelectionMode={false}
            />
            <ToggleSibligsButtons match={match} />
            {isLoading && <div className="Content__sidenavLoading" />}
            <NavigationContainer
                location={location}
                match={match}
                isModalSelectionMode={false}
            />
        </div>
    );
}
